import { useHistory } from 'react-router-dom';
import { Typography } from '../components/Typography';
import { FormattedMessage } from 'react-intl';
import { Button } from '@material-ui/core';

export const NotFound = () => {
  const history = useHistory();
  return (
    <div id="not-found-page">
      <Typography variant="h3" component="h2" color="textPrimary">
        <FormattedMessage id="pageNotFound" />
      </Typography>
      <Button type="button" onClick={() => history.push('/')} variant="outlined">
        <FormattedMessage id="back_to_home" />
      </Button>
    </div>
  );
};
